import { UnknownBlueprint } from '../types';

export const u2 = (inBlueprint: UnknownBlueprint): [UnknownBlueprint, boolean] => {
	console.log('schema-update:process-update:2:unsupported');
	inBlueprint.schemaVersion = 2;
	return [inBlueprint, false];
};
